import { render, staticRenderFns } from "./add_package.vue?vue&type=template&id=21700e7e&scoped=true"
import script from "./add_package.vue?vue&type=script&lang=js"
export * from "./add_package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21700e7e",
  null
  
)

export default component.exports